/* 🤖 this file was generated by svg-to-ts */
export const siriusMagnifyingGlassMinus: {
  name: 'magnifying_glass_minus';
  data: string;
} = {
  name: 'magnifying_glass_minus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M7.125 10.875a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M2.25 10.875a8.625 8.625 0 1 1 15.231 5.546l4.05 4.049a.75.75 0 1 1-1.061 1.06l-4.05-4.049a8.625 8.625 0 0 1-14.17-6.606Zm8.625-7.125a7.125 7.125 0 1 0 0 14.25 7.125 7.125 0 0 0 0-14.25Z" fill="currentColor"/></svg>`
};
